import { useState, useEffect } from 'react';
import { Button, Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ApiFetch } from '../../Utils/ApiFetch';
import useGlobalContext from '../../Hooks/useGlobalContext';
import ModalMessage from '../../Components/Feature/ModalMessage';
import { getEntityIdByName } from '../../Helpers/namedEntities';

const initialState = {
  value: '',
  autocomplete_module_replace_fields: [],
};

const LoadEntity = (props) => {
  const { t } = useTranslation();
  const globalContext = useGlobalContext();
  const [waitModal, setWaitModal] = useState(false);
  const [entityData, setEntityData] = useState(initialState);
  const [fieldsComplete, setFieldsComplete] = useState(false);

  useEffect(() => {
    if (props.entity && props.entityType) {
      setWaitModal(true);
      ApiFetch(
        `autocomplete/${props.entityType}/${props.entity.id}`,
        globalContext,
        false,
        async (res) => {
          if (res.status === 200) {
            let data = await res.json();
            setEntityData({
              value: data.value,
              autocomplete_module_replace_fields:
                data.autocomplete_module_replace_fields,
            });
            setWaitModal(false);
          } else {
            setWaitModal(false);
            props.launchToast(t('namedEntities.toastMessages.getError'));
          }
        },
        (error) => {
          setWaitModal(false);
          props.launchToast(t('namedEntities.toastMessages.getError'));
        },
        {
          method: 'GET',
        }
      );
    }
  }, []);

  const handleChangeData = (event) => {    
    setEntityData({ ...entityData, value: event.target.value });
  };

  const handleSave = () => {
    setWaitModal(true);
    let options = {
      method: props.entity ? 'PUT' : 'POST',
      body: JSON.stringify(entityData),
    };

    let url = props.entity
      ? `autocomplete/${props.entity.id}`
      : `autocomplete/${getEntityIdByName(props.entityType)}`;

    ApiFetch(
      url,
      globalContext,
      true,
      (res) => {
        if (res.status === 200) {
          setWaitModal(false);
          props.entity
            ? props.setEditEntity(false)
            : props.setLoadEntity(false);
          props.reload();
        } else {
          setWaitModal(false);
          props.launchToast(
            props.entity
              ? t('namedEntities.toastMessages.putError')
              : t('namedEntities.toastMessages.postError')
          );
        }
      },
      (error) => {
        setWaitModal(false);
        props.launchToast(
          props.entity
            ? t('namedEntities.toastMessages.putError')
            : t('namedEntities.toastMessages.postError')
        );
      },
      options
    );

    props.launchToast(
      props.entity
        ? t('namedEntities.toastMessages.put')
        : t('namedEntities.toastMessages.post')
    );
    props.reload();
  };

  const validateFields = () => {
    let complete = entityData.value !== '';
    setFieldsComplete(complete);
  };

  useEffect(() => {
    validateFields();
  }, [entityData]);

  return (
    <>
      <ModalMessage
        open={waitModal}
        toggleModal={() => {}}
        modalText={t('component.processing')}
      />
      <Grid container justifyContent="center" alignItems="center" gap={2}>
        <Grid item xs={12}>
          <TextField
            type="text"
            size="small"
            fullWidth
            required
            label={t('namedEntities.entities.name', { entity: t(`namedEntities.entities.${props.entityType}`), })}
            value={entityData.value ? entityData.value : null}
            onChange={handleChangeData}
            InputLabelProps={entityData.value ? { shrink: true } : {}}
          />
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          gap={1}
          pb={1}>
          <Button
            variant="outlined"
            onClick={() =>
              props.entity
                ? props.setEditEntity(false)
                : props.setLoadEntity(false)
            }>
            {t('stepByStep.button.back')}
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!fieldsComplete}>
            {t('namedEntities.formLabel.loadButton')}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default LoadEntity;
